import "./InvoiceViewer.css";

import { useRef } from "react";
import { createPortal } from "react-dom";

import InvoiceHeader from "./InvoiceHeader";
import InvoiceFiscalCard from "./InvoiceFiscalCard";
import InvoiceCustomerCard from "./InvoiceCustomerCard";
import InvoiceItemsTable from "./InvoiceItemsTable";
import InvoiceSummary from "./InvoiceSummary";
import InvoiceActions from "./InvoiceActions";
import InvoiceAdditionalInfo from "./InvoiceAdditionalInfo";

export default function InvoiceViewer({
  invoice,
  company,
  invoiceSettings,
  customer,
  summary,
  onClose,
}) {
  const invoiceRef = useRef(null);

  if (!invoice) return null;

  return createPortal(
    <div
      className="invoice-viewer-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="invoice-viewer-title"
    >
      <section className="invoice-viewer-dialog">
        <header className="invoice-viewer-header">
          <div>
            <span>Documento de venta</span>
            <h2 id="invoice-viewer-title">
              Factura {invoice.number}
            </h2>
          </div>

          <button
            type="button"
            className="invoice-viewer-close"
            onClick={onClose}
            aria-label="Cerrar factura"
          >
            ×
          </button>
        </header>

        <main className="invoice-viewer-body">
          <article ref={invoiceRef} className="invoice-paper">
            <InvoiceHeader
              invoice={invoice}
              company={company}
              invoiceSettings={invoiceSettings}
            />

            <section className="invoice-info-grid">
              <InvoiceFiscalCard
                invoiceSettings={invoiceSettings}
                company={company}
              />

              <InvoiceCustomerCard
                customer={customer}
                invoice={invoice}
              />
            </section>

            <InvoiceItemsTable items={invoice.items || []} />

            <InvoiceSummary
              invoice={invoice}
              summary={summary}
            />
            <InvoiceAdditionalInfo invoice={invoice} />
          </article>
        </main>

        <div className="modal-footer invoice-viewer-footer">
          <InvoiceActions
            invoice={invoice}
            invoiceRef={invoiceRef}
          />
        </div>
      </section>
    </div>,
    document.body
  );
}